import storeModuleCreators from '../../utils/store';
import ReportRepository from '../../repositories/Admin/ReportRepository';

const { createShowActionStoreModule } = storeModuleCreators;

export const { slice, selectors, useActions } = createShowActionStoreModule({
  slicePath: ['admin', 'reports', 'cashbacksData'],
  repositoryAction: ReportRepository.getCashbacksData,
});

export default slice.reducer;
